import React, { useState, useEffect } from 'react';
import Home from './Home'; // Your login page
import LandingPage from './LandingPage'; // Your main candidate management page

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState(null); // Store user role

  // Check authentication status on app load
  useEffect(() => {
    checkAuthStatus();
  }, []);

  // Set up global logout handler that LandingPage can call
  useEffect(() => {
    window.handleAppLogout = handleLogout;
    
    return () => {
      delete window.handleAppLogout;
    };
  }, []);

  const checkAuthStatus = () => {
  try {
    console.log('🔍 Checking authentication status...');
    
    const authToken = localStorage.getItem('session_token');
    const userSession = localStorage.getItem('user');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    
    // Get user role
    let storedRole = localStorage.getItem('userRole');
    
    // If userRole not stored separately, try to get it from user object
    if (!storedRole && userSession) {
      try {
        const userData = JSON.parse(userSession);
        storedRole = userData.role;
      } catch (e) {
        console.error('Error parsing user session:', e);
      }
    }
    
    console.log('🔎 Auth check:', { 
      authToken: !!authToken, 
      userSession: !!userSession, 
      isLoggedIn,
      userRole: storedRole 
    });
    
    if ((authToken || userSession) && isLoggedIn === 'true') {
      console.log('✅ User is authenticated');
      console.log('👤 User role:', storedRole);
      setIsAuthenticated(true);
      setUserRole(storedRole);
    } else {
      console.log('❌ User is not authenticated');
      setIsAuthenticated(false);
      setUserRole(null);
    }
  } catch (error) {
    console.error('❌ Error checking auth status:', error);
    setIsAuthenticated(false);
    setUserRole(null);
  } finally {
    setIsLoading(false);
  }
};

  // Handle successful login - matches your Home.jsx structure
  const handleLoginSuccess = (userData) => {
    try {
      console.log('✅ Login successful in App.jsx:', userData);
      
      // Extract role from userData
      const role = userData.role || userData.userRole || userData.position || 'account_manager';
      
      console.log('👤 User role:', role);
      
      // Store role in localStorage
      localStorage.setItem('userRole', role);
      
      // Update authentication state
      setIsAuthenticated(true);
      setUserRole(role);
      
      // You could also store user data if needed
      // localStorage.setItem('user', JSON.stringify(userData));
      // localStorage.setItem('isLoggedIn', 'true');
    } catch (error) {
      console.error('❌ Error handling login:', error);
    }
  };

  // Handle logout
  const handleLogout = () => {
    try {
      console.log('🔴 Logout initiated...');
      
      // Clear authentication data
      localStorage.removeItem('session_token');
      localStorage.removeItem('user');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userSession');
      localStorage.removeItem('userRole'); // Clear role
      sessionStorage.clear();
      
      console.log('🗑️ All auth data cleared');
      
      // Update authentication state
      setIsAuthenticated(false);
      setUserRole(null);
      
      console.log('✅ Logout complete - redirecting to login');
    } catch (error) {
      console.error('❌ Error handling logout:', error);
      // Force logout anyway
      setIsAuthenticated(false);
      setUserRole(null);
    }
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Render appropriate component based on authentication status
  return (
    <div className="App">
      {isAuthenticated ? (
        // User is logged in - show main application with role info
        <LandingPage 
          onLogout={handleLogout} 
          userRole={userRole}
        />
      ) : (
        // User is not logged in - show login page (your existing Home.jsx)
        <Home onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
};

export default App;